import { gql } from '@apollo/client'
export const queryTicketsList = gql`
query TicketsList($page: Int!, $count: Int!, $ticketsListId: Int, $level1: String, $level2: String,
   $startDate: Date, $endDate: Date, $deviceType: String, $deviceModel: String, $fv: String, $hv: String,
    $appVersion: String, $phoneModel: String, $phoneOs: String, $appId: String, $channel: String,
     $ignore: Boolean, $mac: String, $category: String,$customerSource: String) {

  ticketsList(page: $page, count: $count, id: $ticketsListId, level1: $level1, level2: $level2,
     startDate: $startDate, endDate: $endDate, deviceType: $deviceType, deviceModel: $deviceModel,
      fv: $fv, hv: $hv, appVersion: $appVersion, phoneModel: $phoneModel, phoneOS: $phoneOs,
       appId: $appId, channel: $channel, ignore: $ignore, mac: $mac, category: $category,customerSource: $customerSource) {
    data {
      id
      ticketId
      userId
      userName
      appId
      priority
      deviceType
      deviceModel
      fv
      hv
      appVersion
      phoneOS
      phoneModel
      issueType
      level1
      level2
      env
      comment
      channel
      attachements {
        fileName
        fileUrl
      }
      createdAt
      mac
      ticketStatus
      jiraID
      isTest
      customerSource
    }
    total
  }
}
`

export const syncZendeskToJira = gql`
mutation SyncZendeskToJira($syncZendeskToJiraId: Int!, $projectId: Int!, $issueType: Int!,$assignTo:String!) {
  syncZendeskToJira(id: $syncZendeskToJiraId, projectId: $projectId, issueType: $issueType ,assignTo:$assignTo) {
    jiraId
    link
  }
}
`

export const SyncReveiwToJira = gql`
mutation SyncReveiwToJira($syncReveiwToJiraId: String!, $platform: AppPlatform!, $projectId: Int!, $issueType: Int!) {
  syncReveiwToJira(id: $syncReveiwToJiraId, platform: $platform, projectId: $projectId, issueType: $issueType) {
    jiraId
    link
  }
}
`

export const queryZendeskProjectConfig = gql`
query Query {
  zendeskProjectConfig {
    issueType {
       display
      id
    }
    projectId
    projectName
  }
}
`
export const UpdateFeedbackStatus = gql`
mutation UpdateFeedbackStatus($updateFeedbackStatusId: Int!, $status: TicketStatus!, $level1: String, $level2: String) {
  updateFeedbackStatus(id: $updateFeedbackStatusId, status: $status, level1: $level1, level2: $level2) {
    ticketId
    jiraID
    ticketStatus
    level1
    level2
    id
  }
}`
export const queryJiraMembers = gql`
query JiraMembers {
  jiraMembers {
    accountId
    email
    name
  }
}`

export const queryFeedbackLevels = gql`
query FeedbackLevels {
  feedbackLevels {
    level
    subLevel
  }
}`